/* KUTEN｡商品ページの追加パーツ
   1) スマホの商品画像：写真ごとに縦横比がバラバラだと、一番縦長の写真に合わせて
      スライダーの行の高さが決まり、今見えている写真の上下に白い余白ができる
      （Dawn標準の挙動。パソコンでは「今見えていない写真」をdisplay:noneで消すため起きない）。
      今見えている写真の高さに行の高さをそろえて余白をなくす
   1.5) 「サイズ」の選択肢見出し（variant-selects）に、選んでいるサイズの人数の目安
      （4〜6名・6〜8名）を1行でまとめて表示し、選び直すたびに切り替える
   1.6) スマホ幅で、数量の選択とカートに追加するボタンを横1列に並べる
      （.product-form__quantityとボタンの入れ物を.kt-buy-rowで囲むだけで、
      見た目はCSS側が担当）
   1.7) 価格と星のプレビュー（Judge.me）を同じ行にまとめる（左に価格、右に星）。
      レビュー0件のときは星の入れ物が非表示のままなので、価格だけが残る
   1.8) 星プレビューの件数表示を「3件のレビュー」から「3件」に短くする
   2) 「ギフトにも」のeギフト案内から、購入欄のAll in Giftブロック（「お届け方法」）まで
      ページ移動せずになめらかにスクロールする
   3) お客様の声（Judge.me）：最新3件まで表示し、4件目以降は「すべてのレビューを見る」で開く。
      投稿者名を「姓 名」の順に入れ替え、本文の改行をなくして1段落につなげ、
      4行まで（長いときだけ「続きを読む」）に省略する。
      Judge.meの管理画面の設定は変えず、読み込み完了後のDOMをJSだけで調整する。
      新旧2つのウィジェット（.jdgm-widget-revamp / 旧来の.jdgm-rev系）が商品ごとに
      混在しているため、どちらにも対応し、Judge.meが中身を書き換えても再適用する
   （メッセージプレートはカートの備考欄、お届け・受取希望日はカートの配送日時アプリに
   一本化したため、商品ページ側に入力欄は無い。CLAUDE.md参照） */
(() => {
  if (window.kutenProductInit) return;
  window.kutenProductInit = true;

  // 1) スマホのスライダーの高さを、今見えている写真に合わせる
  const setupGalleryHeight = () => {
    const mq = window.matchMedia('(max-width: 749px)');

    document.querySelectorAll('.product__media-list').forEach((list) => {
      const items = list.querySelectorAll('.product__media-item');
      if (items.length < 2) return;

      const applyHeight = () => {
        if (!mq.matches) {
          list.style.height = '';
          return;
        }
        const active =
          list.querySelector('.product__media-item.is-active .product-media-container') ||
          list.querySelector('.product__media-item .product-media-container');
        if (!active) return;
        const height = active.getBoundingClientRect().height;
        if (height > 0) list.style.height = `${height}px`;
      };

      applyHeight();
      window.addEventListener('resize', applyHeight);
      mq.addEventListener('change', applyHeight);
      new MutationObserver(applyHeight).observe(list, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true,
      });
    });
  };

  // 1.5) 「サイズ」の選択肢見出しに、選んでいるサイズの人数の目安を1行でまとめて表示する。
  //      対象はvariant-selects内で、data-option-nameが「サイズ」のinputを持つfieldset。
  //      選択肢の値（5号・7号を含む文字列。カットの有無などが混ざっていてもよい）から、
  //      該当する号数の人数の目安だけをこちらで組み立てて表示する（値をそのまま出すと
  //      「7号  (21cm)」のような商品データの表記ゆれがそのまま出てしまうため）。
  //      すでに選択肢の文字自体に人数（「名」）が含まれる場合は、二重に出さない。
  const SIZE_CAPACITY = [
    [/5号/, '5号（15cm）・4〜6名'],
    [/7号/, '7号（21cm）・6〜8名'],
  ];

  const buildSizeCapacityText = (value) => {
    if (!value || value.includes('名')) return '';
    const hit = SIZE_CAPACITY.find(([re]) => re.test(value));
    return hit ? hit[1] : '';
  };

  const applySizeCapacity = (root) => {
    const sizeInput = root.querySelector('input[data-option-name="サイズ"]');
    if (!sizeInput) return;
    const fieldset = sizeInput.closest('fieldset');
    const legend = fieldset && fieldset.querySelector('legend');
    if (!fieldset || !legend) return;

    let capacityEl = legend.querySelector('.kt-size-capacity');
    if (!capacityEl) {
      capacityEl = document.createElement('span');
      capacityEl.className = 'kt-size-capacity';
      legend.appendChild(capacityEl);
    }

    const checked = fieldset.querySelector('input[data-option-name="サイズ"]:checked');
    const text = buildSizeCapacityText(checked && checked.value);
    const target = text ? `　${text}` : '';
    // 内容が同じでも書き込むとDOMの変化として検知され、document.bodyを監視する
    // MutationObserverを無限に呼び直してしまうため、変わるときだけ書き込む。
    if (capacityEl.textContent !== target) capacityEl.textContent = target;

    if (!fieldset.dataset.ktSizeBound) {
      fieldset.dataset.ktSizeBound = '1';
      fieldset.addEventListener('change', () => applySizeCapacity(root));
    }
  };

  // Shopify標準のオプション切り替え（product-info.js）は、別のオプション
  // （例：カット）を変えたときにvariant-selectsの中身ごと作り直すことがあり、
  // そのたびに追加したspan・change監視が消えてしまう。document.bodyを
  // 監視して、変化のたびに作り直す（中身で済んでいるか判断するため、
  // 繰り返し呼んでも無駄にはならない）。
  const setupSizeCapacity = () => {
    const runOnce = () => {
      document.querySelectorAll('variant-selects').forEach((root) => {
        try {
          applySizeCapacity(root);
        } catch (e) {
          /* 想定外の構造のときは元の表示のまま */
        }
      });
    };
    runOnce();
    new MutationObserver(runOnce).observe(document.body, { childList: true, subtree: true });
  };

  // 1.6) スマホ幅で、数量の選択とカートに追加するボタンを横1列に並べるための下準備。
  //      .product-form__quantity（数量）とその次の兄弟要素（カートに追加するボタンの
  //      入れ物）を、新しく作る.kt-buy-rowでまとめて囲む（中身は移動するだけで、
  //      要素そのものは作り直さない）。見た目（flex化）はCSS側（kuten-product.css）が
  //      担当し、パソコン幅ではdisplay: contentsにして元の並びのまま見せる。
  const setupBuyRow = () => {
    document.querySelectorAll('.product-form__quantity').forEach((qty) => {
      if (qty.closest('.kt-buy-row')) return;
      const buyWrap = qty.nextElementSibling;
      if (!buyWrap || !buyWrap.querySelector('.product-form__submit')) return;
      const row = document.createElement('div');
      row.className = 'kt-buy-row';
      qty.parentNode.insertBefore(row, qty);
      row.appendChild(qty);
      row.appendChild(buyWrap);
    });
  };

  // 1.7) 価格の行に、星のプレビュー（Judge.me）を同じ行でまとめる下準備。
  //      価格の入れ物（div#price-xxx）・「（税込）」（.product__tax）・星プレビュー
  //      （judge_me_reviews_preview_badgeブロック）は、もとは縦に並ぶ別々の
  //      直接の子要素だったが、新しく作る.kt-rating-price-rowでこの3つだけを
  //      まとめて囲む（中身は移動するだけ）。見た目（左に価格・右に星、flex化）は
  //      CSS側（kuten-product.css）が担当する。星プレビューの入れ物自体は
  //      レビュー0件のとき display:none のまま（kuten-staff-comment.liquid）なので、
  //      その場合はこの行に価格だけが残る。
  const setupRatingPriceRow = () => {
    const price = document.querySelector('div[id^="price-"][role="status"]');
    if (!price || price.closest('.kt-rating-price-row')) return;
    const badge = document.querySelector('[id$="__judge_me_reviews_preview_badge"]');
    if (!badge) return;
    const tax = document.querySelector('.product__tax');
    const row = document.createElement('div');
    row.className = 'kt-rating-price-row';
    price.parentNode.insertBefore(row, price);
    row.appendChild(price);
    if (tax) row.appendChild(tax);
    row.appendChild(badge);
  };

  // 1.8) 星プレビューの件数表示を「3件のレビュー」から「3件」に短くする
  //      （価格と同じ行に収めるため）。Judge.meが書き込む件数
  //      （data-number-of-reviews）をもとに組み立て直すので、文言が
  //      変わっても件数だけは正しく追従する。Judge.meが中身を書き換える
  //      ことがあるため、MutationObserverで監視して変化のたびに作り直す
  //      （内容が同じときは書き込まない＝無限ループ防止）。
  const setupPreviewBadgeCount = () => {
    const runOnce = () => {
      document.querySelectorAll('.jdgm-prev-badge').forEach((badge) => {
        try {
          const count = parseInt(badge.dataset.numberOfReviews, 10);
          const textEl = badge.querySelector('.jdgm-prev-badge__text');
          if (!textEl || Number.isNaN(count)) return;
          const target = `${count}件`;
          if (textEl.textContent !== target) textEl.textContent = target;
        } catch (e) {
          /* 想定外の構造のときは元の表示のまま */
        }
      });
    };
    runOnce();
    new MutationObserver(runOnce).observe(document.body, { childList: true, subtree: true });
  };

  // 1.9) 配送日時アプリ（AMP／配送日時指定）の「最短お届け可能日時の表示」
  //      ブロックを、購入欄のまわり（カートに追加するボタンの直下）へ移動する。
  //      このブロックはアプリ自身が商品ページの別のセクション（kuten-min-delivery.liquidの
  //      入れ物とは別の、テーマエディタで追加された単独の「アプリ」セクション）に
  //      JavaScriptで後から描画するため、テンプレートのJSON（Liquidの配置）だけでは
  //      位置を変えられない。描画され次第、本物のDOM要素（appBlock）をそのまま
  //      移動する（複製ではないため、アプリ自身が付けたイベント処理やidはそのまま効く。
  //      カウントダウンの更新も同じ要素に対して続けられる）。
  //      元のセクションはCSS側（kuten-product.css）で常時非表示にしているため、
  //      移動が終わるまでの間に古い位置（中央寄せ・青文字）が見えることはない。
  //      移動先の入れ物（#kt-min-delivery）もアプリの中身が入るまでhiddenのままにして、
  //      空の行が一瞬見えることも防ぐ。アプリが描画されない場合は、入れ物は
  //      hiddenのまま残り、ページには何も影響しない。
  const setupMinDeliveryDate = () => {
    const anchor = document.getElementById('kt-min-delivery');
    const slot = document.getElementById('kt-min-delivery-content');
    if (!anchor || !slot) return;

    // 日付部分を<strong>で囲んで太字にする処理は廃止した。アプリはカウントダウン
    // （あと何時間か）の更新のたびに1行目の文字列をまるごと作り直しており、
    // こちらが差し替えた<strong>要素を「元の文字列と型が違うもの」として扱って
    // しまうらしく、新しい日付のテキストノードを重ねて挿入する不具合
    // （「10月25日(日)10月25日(日)」のような表示重複）が起きていた。
    // 日付のテキストノード自体には触れず、1行目はアプリが描画した文字列を
    // そのまま使う（太さの見た目はCSS側で一律指定）。

    // 「？」（アプリの説明吹き出し）を、1行目の末尾（日付のすぐ後ろ、<br>の前）へ
    // 移動する。アプリの元の作りでは、1行目・2行目をまとめた<p>（caution）と
    // 「？」の入れ物（.pop-over__container）が横に並ぶ別々の要素のため、CSSの
    // 指定だけでは「1行目の末尾」に揃えられない。すでにcautionの中にあれば
    // （前回ので済んでいる）何もしない。
    const movePopover = () => {
      const caution = slot.querySelector('.delivery-mindate-caution');
      const popover = slot.querySelector('.pop-over__container');
      if (!caution || !popover || caution.contains(popover)) return;
      const br = caution.querySelector('br');
      if (br) {
        caution.insertBefore(popover, br);
      } else {
        caution.appendChild(popover);
      }
    };

    // アプリは、カウントダウン（あと何時間か）を一定時間ごとに自分で書き換える
    // （同じidの要素の中身を作り直す）ため、移動後も「？」の位置が元に戻って
    // しまうことがある。一度移動したら監視をやめるのではなく、Judge.meの調整
    // （setupReviews）と同じように、変化のたびに毎回「まだやる必要があるか」を
    // DOMの中身で判断し直す（移動済みなら「？」の移動だけ、内容が同じなら
    // 何もしない＝無限ループにはならない）。
    const tryMove = () => {
      try {
        if (slot.contains(document.getElementById('cart-delivery-datetime_display-min-delivery-date'))) {
          movePopover();
          return;
        }
        const appBlock = document.querySelector('[id*="__amp_min_delivery_date_block_"]');
        const inner =
          appBlock && appBlock.querySelector('#cart-delivery-datetime_display-min-delivery-date');
        if (!inner || !inner.querySelector('.delivery-mindate-caution')) return;

        slot.appendChild(inner);
        anchor.hidden = false;
        movePopover();
      } catch (e) {
        // 想定外の構造のときは、入れ物をhiddenのままにして元の表示（非表示）を保つ
      }
    };

    tryMove();
    new MutationObserver(tryMove).observe(document.body, { childList: true, subtree: true });
  };

  // 2) 「お届け方法」（All in Giftブロック）までスクロール
  const setupGiftScroll = () => {
    document.querySelectorAll('[data-kt-scroll-to="gift"]').forEach((link) => {
      link.addEventListener('click', () => {
        const target =
          document.querySelector('[id*="all_in_gift_app_block_product"]') ||
          document.querySelector('form[data-type="add-to-cart-form"]');
        if (!target) return;
        const headerHeight =
          parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
        const top = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 16;
        window.scrollTo({ top, behavior: 'smooth' });
      });
    });
  };

  // 3) お客様の声（Judge.me）の調整
  //    2026年10月時点で、Judge.meは新しいウィジェット（Vueで描画される
  //    .jdgm-widget-revamp、クラス名はjm-で始まる）と、これまでのウィジェット
  //    （.jdgm-rev系のクラス）が商品ごとに混在して配信されている（切り替えの
  //    途中と見られる）。どちらが来ても崩れないよう、読み込み完了後にどちらの
  //    版かを判定して処理を振り分ける。新しい版はあとからJudge.me自身が中身を
  //    書き換えることがあるため、一度きりではなく変化のたびに作り直す
  //    （各処理は「やることが済んでいれば何もしない」よう印を付けてあるので、
  //    同じ場所を無限に処理し続けることはない）。
  const REVIEW_LIMIT = 3;

  const isAlnum = (ch) => /[A-Za-z0-9]/.test(ch);

  // 要素の中の改行（<br>・段落区切り）をなくして1段落の文字列にする。
  // つなぎ目の前後がどちらも半角英数字のときだけ、間に半角スペースを1つ入れる。
  const mergeLineBreaks = (sourceEl) => {
    const clone = sourceEl.cloneNode(true);
    const BREAK = '@@KT_BREAK@@';
    clone.querySelectorAll('br').forEach((br) => {
      br.replaceWith(document.createTextNode(BREAK));
    });
    const paragraphs = clone.querySelectorAll('p');
    paragraphs.forEach((p, i) => {
      if (i === 0) return;
      p.insertBefore(document.createTextNode(BREAK), p.firstChild);
    });

    const segments = clone.textContent
      .split(BREAK)
      .map((s) => s.trim())
      .filter((s) => s.length);

    let merged = '';
    segments.forEach((seg, i) => {
      if (i === 0) {
        merged = seg;
        return;
      }
      const prevChar = merged.slice(-1);
      const nextChar = seg.charAt(0);
      merged += isAlnum(prevChar) && isAlnum(nextChar) ? ` ${seg}` : seg;
    });
    return merged;
  };

  // 漢字・ひらがな・カタカナ（半角カタカナ含む）が含まれているかどうか。
  const hasJapaneseChar = (text) => /[぀-ヿ一-鿿ｦ-ﾝ]/.test(text);

  // 半角・全角スペースで2語に分かれ、両方の語に日本語の文字（漢字・ひらがな・カタカナ）が
  // 含まれる名前（例：順一 千星、カナコ イシイ）だけ「姓 名」に入れ替える。
  // 「美知子」のような1語の名前や、「GONDO SEINA」のようなローマ字の名前はそのまま返す
  // （ローマ字は投稿された順がすでに姓・名の並びのことが多く、入れ替えると崩れるため）。
  const swapToSurnameFirst = (text) => {
    const parts = text.trim().split(/[ 　]+/).filter(Boolean);
    if (parts.length !== 2) return text;
    if (!hasJapaneseChar(parts[0]) || !hasJapaneseChar(parts[1])) return text;
    return `${parts[1]} ${parts[0]}`;
  };

  // ---------------------------------------------------------------
  // 旧版（.jdgm-rev 系のクラス）
  // ---------------------------------------------------------------

  const formatReviewSummary = (widget) => {
    const revWidg = widget.querySelector('.jdgm-rev-widg');
    if (!revWidg) return;
    const avg = parseFloat(revWidg.dataset.averageRating);
    const count = parseInt(revWidg.dataset.numberOfReviews, 10);
    if (Number.isNaN(avg) || Number.isNaN(count)) return;
    const avgEl = revWidg.querySelector('.jdgm-rev-widg__summary-average');
    const textEl = revWidg.querySelector('.jdgm-rev-widg__summary-text');
    if (!avgEl || !textEl) return;
    // 同じ内容でも書き込むとDOMの変化として検知されてしまうため、
    // 変わるときだけ書き込む（繰り返し処理しても無限ループにならないようにする）。
    const target = `${avg.toFixed(1)}（${count}件のレビュー）`;
    if (avgEl.textContent !== target) avgEl.textContent = target;
    if (textEl.style.display !== 'none') textEl.style.display = 'none';
  };

  const swapReviewAuthorName = (review) => {
    const author = review.querySelector('.jdgm-rev__author');
    if (!author || author.dataset.ktSwapped) return;
    author.dataset.ktSwapped = '1';
    author.textContent = swapToSurnameFirst(author.textContent);
  };

  const mergeReviewBody = (review) => {
    const body = review.querySelector('.jdgm-rev__body');
    if (!body) return;
    // 印（data属性）ではなく、<br>や複数の<p>が残っているかで「つなげる必要があるか」を
    // 判断する。すでにつなげたあとはこの条件に当てはまらず、何もしない（＝繰り返し
    // 呼んでも無限ループにならない）。Judge.meが本文を書き換えて<br>が戻ってきたときは、
    // 次に呼ばれたときにまたつなげ直せる。
    const needsMerge = body.querySelector('br') || body.querySelectorAll('p').length > 1;
    if (!needsMerge) return;
    body.textContent = mergeLineBreaks(body);
  };

  const setupReviewClamp = (review) => {
    const body = review.querySelector('.jdgm-rev__body');
    if (!body || body.dataset.ktClamped) return;
    body.dataset.ktClamped = '1';
    // clampをかける前（まだ折り返した自然な高さ）のscrollHeightを、4行分の高さと比べて判定する。
    // 先にkt-rev-clampを付けてからscrollHeightを見る方法は、ブラウザによっては
    // クランプ後の高さをそのまま返すことがあり、省略されていても判定できないため使わない。
    // また、4件目以降は後で非表示にする（display:noneだとscrollHeightが0になり
    // 正しく測れない）ため、この判定は非表示にする前の同期処理で行う。
    const cs = getComputedStyle(body);
    let lineHeight = parseFloat(cs.lineHeight);
    if (!lineHeight || Number.isNaN(lineHeight)) {
      lineHeight = parseFloat(cs.fontSize) * 1.5;
    }
    const maxHeight = lineHeight * 4;
    const naturalHeight = body.scrollHeight;
    if (naturalHeight <= maxHeight + 1) return;

    body.classList.add('kt-rev-clamp');
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kt-rev-readmore';
    btn.textContent = '続きを読む';
    btn.addEventListener(
      'click',
      () => {
        body.classList.remove('kt-rev-clamp');
        btn.remove();
      },
      { once: true }
    );
    body.insertAdjacentElement('afterend', btn);
  };

  const setupReviewShowMore = (widget, reviews) => {
    // 「やることが済んでいる」印はreviews自体ではなく一覧の入れ物に付ける。
    // 一度ボタンを押して全件表示にしたあと、Judge.meの再描画などでこの処理が
    // もう一度走っても、非表示に戻したりボタンを二重に出したりしないようにするため。
    const container = widget.querySelector('.jdgm-rev-widg__reviews');
    if (!container || container.dataset.ktShowMoreDone) return;
    if (reviews.length <= REVIEW_LIMIT) return;
    container.dataset.ktShowMoreDone = '1';

    const revWidg = widget.querySelector('.jdgm-rev-widg');
    const count = parseInt(revWidg && revWidg.dataset.numberOfReviews, 10) || reviews.length;
    const paginate = widget.querySelector('.jdgm-paginate');
    const paginateWasVisible = !!paginate && getComputedStyle(paginate).display !== 'none';
    if (paginate) paginate.style.display = 'none';

    const extra = reviews.slice(REVIEW_LIMIT);
    extra.forEach((review) => {
      review.style.display = 'none';
    });

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kt-rev-more';
    btn.textContent = `すべてのレビューを見る（${count}件）`;
    btn.addEventListener(
      'click',
      () => {
        extra.forEach((review) => {
          review.style.display = '';
        });
        if (paginate && paginateWasVisible) paginate.style.display = '';
        btn.remove();
      },
      { once: true }
    );
    reviews[REVIEW_LIMIT - 1].insertAdjacentElement('afterend', btn);
  };

  const runLegacyReviews = (widget) => {
    try {
      formatReviewSummary(widget);
    } catch (e) {
      /* 失敗した場合は元の表示のまま */
    }
    const reviews = Array.from(widget.querySelectorAll('.jdgm-rev-widg__reviews > .jdgm-rev'));
    reviews.forEach((review) => {
      try {
        swapReviewAuthorName(review);
      } catch (e) {
        /* 入れ替えられない名前は元の表示のまま */
      }
      try {
        mergeReviewBody(review);
      } catch (e) {
        /* 失敗した場合は元の本文のまま */
      }
      try {
        setupReviewClamp(review);
      } catch (e) {
        /* 失敗した場合は元の本文のまま */
      }
    });
    try {
      setupReviewShowMore(widget, reviews);
    } catch (e) {
      /* 失敗した場合は元の表示のまま（全件表示） */
    }
  };

  // ---------------------------------------------------------------
  // 新しい版（.jdgm-widget-revamp、クラス名はjm-で始まる）
  // ---------------------------------------------------------------

  // 要約「4.8 5 レビュー」を「★★★★★ 4.8（5件のレビュー）」にする。
  // 星はJudge.me自身が各レビューで使っているのと同じアイコンフォント
  // （JudgemeStar）・同じ文字コード（塗り:  / 空: ）で作る。
  // 件数のテキストだけを書き換えるのは中身（数字）で判断できて自然に繰り返しに強いが、
  // 星を追加したかどうかは内容だけでは判断しづらいため、ここだけ専用のクラス
  // （kt-rev-summary-stars）の有無で「追加済みか」を見る。
  // レビューの総件数（全ページ合計）。要約の件数部分が、Judge.meの実際のデータ上の
  // 総件数のため、ここから取り出す（1ページ目に読み込まれた.jm-review-itemの数とは
  // 別物。1ページ目だけでは全体が8件でも5件などと少なく出てしまう）。
  const getRevampReviewCount = (widget) => {
    const display = widget.querySelector('.jm-average-rating-display');
    if (!display) return null;
    const paras = display.querySelectorAll('p');
    if (paras.length < 2) return null;
    const match = paras[1].textContent.match(/\d+/);
    return match ? parseInt(match[0], 10) : null;
  };

  const formatRevampSummary = (widget) => {
    const display = widget.querySelector('.jm-average-rating-display');
    if (!display) return;
    const paras = display.querySelectorAll('p');
    if (paras.length < 2) return;
    const avgP = paras[0];
    const countP = paras[1];
    const avg = parseFloat(avgP.textContent);
    const count = getRevampReviewCount(widget);
    if (Number.isNaN(avg) || count === null) return;

    // 平均点はJudge.meが出す桁数（4.84など）のままにせず、小数第1位までにそろえる
    const avgTarget = avg.toFixed(1);
    if (avgP.textContent !== avgTarget) avgP.textContent = avgTarget;

    const target = `（${count}件のレビュー）`;
    if (countP.textContent !== target) countP.textContent = target;

    const inner = display.querySelector('.jm-cluster') || display;
    if (inner.querySelector('.kt-rev-summary-stars')) return;
    const filled = Math.round(avg);
    const starsWrap = document.createElement('span');
    starsWrap.className = 'kt-rev-summary-stars';
    for (let i = 0; i < 5; i++) {
      const star = document.createElement('span');
      star.className = 'jm-star-rating__font-icon';
      star.style.color = 'var(--jm-review-widget-star-and-histogram-color)';
      star.textContent = i < filled ? '' : '';
      starsWrap.appendChild(star);
    }
    inner.insertBefore(starsWrap, inner.firstChild);
  };

  const swapRevampReviewerName = (item) => {
    const nameEl = item.querySelector('.jm-reviewer-info__name');
    if (!nameEl || nameEl.dataset.ktSwapped) return;
    nameEl.dataset.ktSwapped = '1';
    const swapped = swapToSurnameFirst(nameEl.textContent);
    nameEl.textContent = swapped;
    nameEl.setAttribute('title', swapped);
  };

  // 本文の改行をつなげたうえで、4行を超えるときだけ「続きを読む」を付ける。
  // Judge.me自身が本文の要素にすでに5行までの折りたたみ（-webkit-line-clamp）を
  // インラインstyleで設定しているので、その仕組みをそのまま間借りして4行に変える
  // （クランプを一旦外して自然な高さを測ってから、あらためて4行に戻す）。
  const clampRevampReviewBody = (item) => {
    const body = item.querySelector('.jm-review-content__body');
    if (!body) return;
    // 印（data属性）ではなく、Judge.me自身が入れている元の入れ物
    // （.jdgm-review-content__body-content）がまだあるかで「未処理かどうか」を
    // 判断する。処理後はこの入れ物ごと置き換えるため無くなり、以後は何もしない
    // （＝繰り返し呼んでも無限ループにならない）。Judge.meが本文を書き換えて
    // この入れ物が戻ってきたときは、次に呼ばれたときにまた処理し直せる。
    const original = body.querySelector('.jdgm-review-content__body-content');
    if (!original) return;
    const existingBtn = body.nextElementSibling;
    if (existingBtn && existingBtn.classList.contains('kt-rev-readmore')) existingBtn.remove();

    body.textContent = mergeLineBreaks(original);

    body.style.display = 'block';
    body.style.webkitLineClamp = '';
    body.style.overflow = 'visible';
    const cs = getComputedStyle(body);
    let lineHeight = parseFloat(cs.lineHeight);
    if (!lineHeight || Number.isNaN(lineHeight)) {
      lineHeight = parseFloat(cs.fontSize) * 1.5;
    }
    const maxHeight = lineHeight * 4;
    const overflowing = body.scrollHeight > maxHeight + 1;

    body.style.display = '-webkit-box';
    body.style.webkitBoxOrient = 'vertical';
    body.style.overflow = 'hidden';
    body.style.webkitLineClamp = '4';

    if (!overflowing) return;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kt-rev-readmore';
    btn.textContent = '続きを読む';
    btn.addEventListener(
      'click',
      () => {
        body.style.webkitLineClamp = 'unset';
        body.style.display = 'block';
        body.style.overflow = 'visible';
        btn.remove();
      },
      { once: true }
    );
    body.insertAdjacentElement('afterend', btn);
  };

  const setupRevampShowMore = (widget, list, items) => {
    if (list.dataset.ktShowMoreDone) return;
    if (items.length <= REVIEW_LIMIT) return;
    list.dataset.ktShowMoreDone = '1';

    const extra = items.slice(REVIEW_LIMIT);
    extra.forEach((item) => {
      item.style.display = 'none';
    });

    // Judge.meのページ送り（1・2・＞）は、「すべてのレビューを見る」を押すまでは隠し、
    // 押したときに1ページ目の残りと一緒に表示する（旧ウィジェットの.jdgm-paginateと
    // 同じ考え方）。2ページ目以降の切り替えはJudge.me自身のページ送りに任せる
    // （ページが切り替わるとjm-review-itemが入れ替わり、MutationObserver経由で
    // runRevampReviewsが再実行されるため、星・名前・本文の調整もそのまま効く）。
    const pagination = widget.querySelector('.jm-pagination-controls');
    const paginationWasVisible = !!pagination && getComputedStyle(pagination).display !== 'none';
    if (pagination) pagination.style.display = 'none';

    const count = getRevampReviewCount(widget) || items.length;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kt-rev-more';
    btn.textContent = `すべてのレビューを見る（${count}件）`;
    btn.addEventListener(
      'click',
      () => {
        extra.forEach((item) => {
          item.style.display = '';
        });
        if (pagination && paginationWasVisible) pagination.style.display = '';
        btn.remove();
      },
      { once: true }
    );
    items[REVIEW_LIMIT - 1].insertAdjacentElement('afterend', btn);
  };

  const runRevampReviews = (widget) => {
    try {
      formatRevampSummary(widget);
    } catch (e) {
      /* 失敗した場合は元の表示のまま */
    }
    const list = widget.querySelector('.jdgm-review-list');
    if (!list) return;
    const items = Array.from(list.children).filter((el) => el.classList.contains('jm-review-item'));
    items.forEach((item) => {
      try {
        swapRevampReviewerName(item);
      } catch (e) {
        /* 入れ替えられない名前は元の表示のまま */
      }
      try {
        clampRevampReviewBody(item);
      } catch (e) {
        /* 失敗した場合は元の本文のまま */
      }
    });
    try {
      setupRevampShowMore(widget, list, items);
    } catch (e) {
      /* 失敗した場合は元の表示のまま（全件表示） */
    }
  };

  // ---------------------------------------------------------------
  // 振り分け
  // ---------------------------------------------------------------

  const isLegacyReady = (widget) => !!widget.querySelector('.jdgm-rev-widg__reviews .jdgm-rev');
  const isRevampReady = (widget) => !!widget.querySelector('.jdgm-review-list .jm-review-item');
  const isReviewWidgetReady = (widget) =>
    widget.classList.contains('jdgm--done-setup-widget') && (isLegacyReady(widget) || isRevampReady(widget));

  // Judge.meの描画は、読み込みの速さによって「最初から整っている」「少し遅れて整う」
  // 「一覧だけ後から差し替わる」など、いつ終わるか・何回書き換わるか決まっていない。
  // そのため「読み込み完了を一度だけ待つ」のではなく、ページの中で何かが変わるたびに
  // #judgeme_product_reviewsを毎回取り直して判定し直す。ウィジェット要素そのものを
  // 閉じ込めて監視するのではなく、要素を直接の監視対象にしないことで、
  // （a）読み込みが遅く、スクリプト実行時点ではまだ存在しない
  // （b）Judge.me側の都合で要素ごと作り直される
  // といった場合にも、次の変化で改めて見つけて処理できるようにしている。
  const setupReviews = () => {
    const runOnce = () => {
      const widget = document.getElementById('judgeme_product_reviews');
      if (!widget || !isReviewWidgetReady(widget)) return;
      try {
        if (isRevampReady(widget)) {
          runRevampReviews(widget);
        } else if (isLegacyReady(widget)) {
          runLegacyReviews(widget);
        }
      } catch (e) {
        /* 何かが変わっていても、ここで止めてJudge.meの元の表示のままにする */
      }
    };

    runOnce();

    // 商品ページ全体（document.body）を監視する。対象をウィジェット自身に絞らないのは、
    // 上記の理由により「監視を始めた時点のウィジェット要素」に依存したくないため。
    // 各処理は内容（DOMの中身）で「まだやる必要があるか」を判断しており、
    // 変化がなければ何もしない作りのため、広く監視しても無駄な書き換えは起きない。
    const observer = new MutationObserver(runOnce);
    observer.observe(document.body, { childList: true, subtree: true });
  };

  const init = () => {
    setupGalleryHeight();
    setupSizeCapacity();
    setupRatingPriceRow();
    setupPreviewBadgeCount();
    setupBuyRow();
    setupMinDeliveryDate();
    setupGiftScroll();
    setupReviews();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
